import { Directive, Input, OnInit, OnDestroy } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { SavedSearchComponent } from '../../components/saved-search/saved-search.component';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appSavedSearchSync]',
})
export class SavedSearchSyncDirective implements OnInit, OnDestroy {
  @Input('appSavedSearchSync') savedSearchComponent?: SavedSearchComponent | null;
  /**
   * When true, gridReady does not call savedSearch.refresh().
   * Use when the page bootstraps saved views itself before attaching an SSRM datasource
   * (avoids an empty first fetch + a second fetch after filters apply).
   */
  @Input() savedSearchDeferRefresh = false;

  private subs = new Subscription();

  constructor(private hostGrid: AgGridAngular) {}

  ngOnInit() {
    const savedSearch = this.savedSearchComponent;
    if (!this.hostGrid || !savedSearch) return;

    this.subs.add(
      this.hostGrid.gridReady.subscribe((event: any) => {
        if (this.savedSearchDeferRefresh) {
          savedSearch.gridApi = event.api;
          return;
        }
        savedSearch.refresh(event.api);
      }),
    );

    this.subs.add(
      this.hostGrid.dragStopped.subscribe((event: any) => {
        savedSearch.handleGridEvent(event);
      }),
    );

    this.subs.add(
      this.hostGrid.filterChanged.subscribe((event: any) => {
        savedSearch.handleGridEvent(event);
      }),
    );

    this.subs.add(
      this.hostGrid.columnVisible.subscribe((event: any) => {
        savedSearch.handleGridEvent(event);
      }),
    );

    this.subs.add(
      this.hostGrid.sortChanged.subscribe((event: any) => {
        savedSearch.handleGridEvent(event);
      }),
    );

    this.subs.add(
      this.hostGrid.columnResized.subscribe((event: any) => {
        if (event.finished) {
          savedSearch.handleGridEvent(event);
        }
      }),
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
